import React from "react";

const TriangleWarningIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 11.5V19"
        stroke="#FFAA2C"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16 24.25V25"
        stroke="#FFAA2C"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M1.34731 26.5244L13.5243 2.57838C14.5938 0.473875 17.4093 0.473875 18.4773 2.57838L30.6528 26.5244C31.6743 28.5404 30.3153 31.0004 28.1733 31.0004H3.82381C1.68331 31.0004 0.322814 28.5404 1.34881 26.5244H1.34731Z"
        stroke="#FFAA2C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default TriangleWarningIcon;
